(() => {
  'use strict';
  const root = document.documentElement;
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const modalSelector = '.rk-at-modal, .rk-tile-modal, .rk-rb-modal, .rk-maglia__modal';
  let active = false;
  let viewportActive = false;
  let raf = 0;
  let timerA = 0;
  let timerB = 0;
  const observed = new WeakSet();

  const isOpen = (modal) => {
    if (!modal || !modal.isConnected) return false;
    if (modal.matches('.rk-tile-modal')) return !modal.hidden && modal.getAttribute('aria-hidden') !== 'true';
    return modal.classList.contains('is-open') || modal.getAttribute('aria-hidden') === 'false';
  };
  const openModal = () => [...document.querySelectorAll(modalSelector)].find(isOpen) || null;

  const updateViewport = () => {
    if (!mobileQuery.matches) return;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const vv = window.visualViewport;
      const height = Math.max(320, Math.round(vv ? vv.height : window.innerHeight));
      root.style.setProperty('--rk-mobile-viewport-height', `${height}px`);
      const layoutHeight = Math.max(window.innerHeight || 0, root.clientHeight || 0);
      root.classList.toggle('rk-mobile-keyboard-open', Boolean(openModal() && vv && layoutHeight && vv.height < layoutHeight * 0.76));
    });
  };
  const addViewport = () => {
    if (viewportActive) return;
    viewportActive = true;
    window.addEventListener('resize', updateViewport, { passive: true });
    if (window.visualViewport) {
      visualViewport.addEventListener('resize', updateViewport, { passive: true });
      visualViewport.addEventListener('scroll', updateViewport, { passive: true });
    }
  };
  const removeViewport = () => {
    if (!viewportActive) return;
    viewportActive = false;
    window.removeEventListener('resize', updateViewport);
    if (window.visualViewport) {
      visualViewport.removeEventListener('resize', updateViewport);
      visualViewport.removeEventListener('scroll', updateViewport);
    }
  };
  const sync = () => {
    if (!mobileQuery.matches) {
      root.classList.remove('rk-configurator-mobile-open', 'rk-mobile-keyboard-open');
      document.body && document.body.classList.remove('rk-configurator-mobile-open');
      removeViewport();
      return;
    }
    const open = Boolean(openModal());
    root.classList.toggle('rk-configurator-mobile-open', open);
    document.body && document.body.classList.toggle('rk-configurator-mobile-open', open);
    if (open) { addViewport(); updateViewport(); }
    else { root.classList.remove('rk-mobile-keyboard-open'); removeViewport(); }
  };

  const modalObserver = new MutationObserver(sync);
  const register = () => document.querySelectorAll(modalSelector).forEach((modal) => {
    if (observed.has(modal)) return;
    observed.add(modal);
    modalObserver.observe(modal, { attributes: true, attributeFilter: ['class','hidden','aria-hidden'] });
  });
  const schedule = () => {
    clearTimeout(timerA); clearTimeout(timerB); register();
    timerA = setTimeout(() => { register(); sync(); }, 0);
    timerB = setTimeout(() => { register(); sync(); }, 180);
  };
  const keepVisible = (event) => {
    if (!mobileQuery.matches || !openModal()) return;
    const field = event.target && event.target.closest ? event.target.closest('input,select,textarea,[contenteditable="true"]') : null;
    if (!field || !field.closest(modalSelector)) return;
    setTimeout(() => {
      try { field.scrollIntoView({ block:'center', inline:'nearest', behavior:'auto' }); }
      catch (_) { field.scrollIntoView(false); }
      updateViewport();
    }, 220);
  };
  const start = () => {
    if (active || !mobileQuery.matches) return;
    active = true; register();
    document.addEventListener('click', schedule, true);
    document.addEventListener('focusin', keepVisible, true);
    document.addEventListener('focusout', updateViewport, true);
    window.addEventListener('orientationchange', schedule, { passive:true });
    sync();
  };
  const stop = () => {
    if (!active) return;
    active = false;
    document.removeEventListener('click', schedule, true);
    document.removeEventListener('focusin', keepVisible, true);
    document.removeEventListener('focusout', updateViewport, true);
    window.removeEventListener('orientationchange', schedule);
    root.classList.remove('rk-configurator-mobile-open','rk-mobile-keyboard-open');
    document.body && document.body.classList.remove('rk-configurator-mobile-open');
    removeViewport();
  };
  const onMedia = () => mobileQuery.matches ? start() : stop();
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onMedia);
  else mobileQuery.addListener(onMedia);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
